import { render, staticRenderFns } from "./CardSalesOrder.vue?vue&type=template&id=783ae28c"
import script from "./CardSalesOrder.vue?vue&type=script&lang=js"
export * from "./CardSalesOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports